/* eslint-disable no-restricted-globals */
import React from 'react';
import { reverb_search_SearchResponse } from '../rql';
import RQLSearchOverview from './rql_search_overview';
import RQLPagination from './rql_pagination';
import { Filter } from './search_filters';
import { Location } from 'history';
import I18n from 'i18n-js';

interface IProps {
  error?: boolean;
  loading?: boolean;
  search: reverb_search_SearchResponse;
  location: Location;
  hasFacets?: boolean;
  hasPagination?: boolean;
  hasSearchOverview?: boolean;
  showSearchControls?: boolean;
  showSimilarListingsMessage?: boolean;
  // this should be a <Tiles> component of cards
  cards: React.ReactNode;
  fallbackCards?: React.ReactNode;
  lowResultsAlert?: React.ReactNode;
  subqueryRows?: React.ReactNode;
  followButton?: React.ReactNode;
  followBanner?: React.ReactNode;
  // Ad Placement Banner
  aboveGridBanner?: React.ReactNode;
  // MarketplaceCSPRow
  relatedSearchRow?: React.ReactNode;
  filters?: Filter[];
  tipText?: string;
  totalText?: string;
  titleOverride?: string;

  // Passed down to facets
  trackingQuery?: string;

  // Adds additional sidebar content below the facets
  // This is used in the MarketplaceGrid to display static promos
  sidebarContent?: React.ReactNode;
  renderSellerLocationFilter?: boolean,
  setListViewState?: (val: boolean) => void;
  showListViewToggle?: boolean;
}

RQLSearchGrid.defaultProps = {
  hasPagination: false,
  hasFacets: false,
  freeTextQueryParam: '',
  collectionHeader: '',
  relatedSearchRow: null,
  error: false,
  showSearchControls: true,
  renderSellerLocationFilter: false,
  trackingQuery: '',
  location: null,
  showListViewToggle: false,
};

export default function RQLSearchGrid(props: IProps) {
  const filters = props.filters || props.search?.filters || [];

  return (
    <div className="faceted-grid faceted-grid--wide">
      {props.aboveGridBanner}
      <div className="faceted-grid__inner">
        <div className="faceted-grid__main">
          {props.showSimilarListingsMessage &&
            <div className="pb-1">
              <h1 className="size-140">{I18n.t('discovery.similarListingsMessage.title')}</h1>
              {I18n.t('discovery.similarListingsMessage.body')}
            </div>
          }
          {props.relatedSearchRow}
          {props.hasSearchOverview && !props.error &&
            <RQLSearchOverview
              filters={filters}
              followButton={props.followButton}
              totalText={props.totalText}
              titleOverride={props.titleOverride}
              resultsTotal={props.search?.total}
              tipText={props.tipText}
              loading={props.loading}
              renderSellerLocationFilter={props.renderSellerLocationFilter}
              trackingQuery={props.trackingQuery}
              // @ts-ignore
              location={location}
              showListViewToggle={props.showListViewToggle}
              setListViewState={props.setListViewState}
            />
          }
          {props.lowResultsAlert}
          {props.cards}
          {props.hasPagination && !props.error && props.search &&
            <RQLPagination
              limit={props.search.limit}
              total={props.search.total}
              offset={props.search.offset}
            />
          }
          {!props.loading && props.followBanner}
          {props.subqueryRows}
          {props.fallbackCards}
        </div>
      </div>
    </div>
  );
}
